import { render, staticRenderFns } from "./gCartList.vue?vue&type=template&id=240c23fc&scoped=true&"
import script from "./gCartList.vue?vue&type=script&lang=js&"
export * from "./gCartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c23fc",
  null
  
)

export default component.exports